import {UserDto} from './user-dto';
import {EmploymentType} from '../enum/employment-type';
import {SalaryType} from '../enum/salary-type';
import {Status} from '../enum/status';
import {InflowType} from '../enum/inflow-type';
import {CareerTargetKind} from '../enum/career-target-kind';
import {DocumentDto} from './document-dto';
import {DepartmentDto} from './department-dto';

export class ProfileDto {

  public id: string;

  public user: UserDto;

  public employeeNr: string | null = null;

  public initials: string;

  public birthDate: Date | null = null;

  public phoneNumber: string | null = null;

  public departments?: DepartmentDto[];

  public departmentIds: string[] | null = null;

  public team: string | null = null;

  public functionId: string | null = null;

  public jobScale: string | null = null;

  public employmentDate: Date;

  public employmentEndDate: Date | null = null;

  public employmentType: EmploymentType;

  public salaryType: SalaryType;

  public contractHours: number | null = null;

  public fte: number;

  public status: Status;

  public linkedInUrl: string | null = null;

  public mySkillsPassport: string | null = null;

  public highestEducation: string;

  public inflowType: InflowType;

  public careerProfileId: string;

  public careerTargetType: CareerTargetKind | null = null;

  public coach: UserDto | null = null;

  public manager: UserDto | null = null;

  public popPmManager: UserDto | null = null;

  public documents: DocumentDto[];

  constructor(id: string, user: UserDto, employeeNr: string | null,
              initials: string, birthDate: Date | null, phoneNumber: string | null,
              team: string | null, functionId: string | null,
              jobScale: string | null, employmentDate: Date, employmentEndDate: Date | null,
              employmentType: EmploymentType, salaryType: SalaryType, contractHours: number | null,
              fte: number, status: Status, linkedInUrl: string | null, mySkillsPassport: string | null,
              highestEducation: string, inflowType: InflowType, careerProfileId: string, careerTargetType: CareerTargetKind | null,
              coach: UserDto | null, manager: UserDto | null, popPmManager: UserDto | null, documents: DocumentDto[],
              departmentIds: string[] | null = null) {
    this.id = id;
    this.user = user;
    this.employeeNr = employeeNr;
    this.initials = initials;
    this.birthDate = birthDate;
    this.phoneNumber = phoneNumber;
    this.departmentIds = departmentIds;
    this.team = team;
    this.functionId = functionId;
    this.jobScale = jobScale;
    this.employmentDate = employmentDate;
    this.employmentEndDate = employmentEndDate;
    this.employmentType = employmentType;
    this.salaryType = salaryType;
    this.contractHours = contractHours;
    this.fte = fte;
    this.status = status;
    this.linkedInUrl = linkedInUrl;
    this.mySkillsPassport = mySkillsPassport;
    this.highestEducation = highestEducation;
    this.inflowType = inflowType;
    this.careerProfileId = careerProfileId;
    this.careerTargetType = careerTargetType;
    this.coach = coach;
    this.manager = manager;
    this.popPmManager = popPmManager;
    this.documents = documents;
  }
}
